import { Premiere } from "@filmweb/sanity-types";
import { parse, isFuture, isSameMonth } from "date-fns";

const stringFormat = "yyyy-MM-dd"

/**
 * Will return true or false unless the premiere is not known
 * @param nationalPremiere
 * @param localPremiere
 */
export default function isPremiereInFuture(nationalPremiere?: Premiere, localPremiere?: string): boolean | undefined {

	let date: Date | null = null;
	if (!localPremiere) {
		if (!nationalPremiere?.noCinemaRelease) {
			if (nationalPremiere?.expectedPremiereDate) {
				date = parse(nationalPremiere!.expectedPremiereDate, stringFormat, new Date());
				if( isFuture(date) || isSameMonth(date, new Date()) ) {
					return true;
				}
				return false;
			}
			if (nationalPremiere?.premiereDate) {
				date = parse(nationalPremiere!.premiereDate, stringFormat, new Date());
			}
		}
	} else {
		date = parse(localPremiere, "yyyy-MM-dd", new Date());
	}

	if (date) {
		return isFuture(date);
	}

	return undefined;

}